/** Shared dropdown width for rights-data entity dropdowns (Writer, Publisher, PRO) */
export const RIGHTS_DROPDOWN_WIDTH = 260
